@if (asset) {
  @if (asset.instrumentType === InstrumentType.Crypto) {
    <shared-micar-contracts-nudging class="d-block mt-3" />
  }
  @if (!errors || errors['experienceAndFtgNotOkay']) {
    @if (hasSpecialTradingHours) {
      <div class="d-flex flex-grow font-size-smaller1 mt-1 justify-content-center">
        {{ 'trade.create.hint.special-trading-hours' | transloco: { tradingHours: tradingHours } }}
      </div>
    }
    @if (direction === 'buy') {
      <trade-check-experience-and-ftg
        [assetToCheck]="asset"
        (allowedToProceedOrderChange)="updateExperienceAndFtgOK($event)"
        (experienceCheckCanceled)="experienceCheckCanceled.emit()"
      />
    }
  } @else {
    @if (errors['noActiveTradingHours']) {
      <div class="mt-2 mb-2 p-2 text-align-center font-size-smaller1 border-error text-danger">
        @if (tradingHours) {
          {{ 'trade.create.hint.special-trading-hours' | transloco: { tradingHours: tradingHours } }}. <br />
        }
        {{ 'trade.create.hint.form-errors.noActiveTradingHours' | transloco }}
      </div>
    }
    @if (errors['derivativeKnockedOut']) {
      <div class="mt-2 mb-2 p-2 text-align-center font-size-smaller1 border-attention">
        {{ 'trade.create.hint.form-errors.derivativeKnockedOut' | transloco }}
      </div>
    }
    @if (errors['derivativeSoldOut']) {
      <div class="mt-2 mb-2 p-2 text-align-center font-size-smaller1 border-attention">
        {{ 'trade.create.hint.form-errors.derivativeSoldOut' | transloco }}
      </div>
    }
    @if (errors['derivativeExpired']) {
      <div class="mt-2 mb-2 p-2 text-align-center font-size-smaller1 border-attention">
        {{ 'trade.create.hint.form-errors.derivativeExpired' | transloco }}
      </div>
    }
  }
}
